'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'person-military-pointing';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e54a';
var svgPathData = 'M256 59.1l0 4.9s0 0 0 0l128 0s0 0 0 0l0-26.2L256 59.1zM398.2 95.2c1.2 5.4 1.8 11 1.8 16.8c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-5.8 .6-11.4 1.8-16.8C231.5 92.4 224 83.1 224 72l0-19.7c0-11.7 8.5-21.7 20.1-23.7l144-24C402.7 2.2 416 13.5 416 28.3L416 72c0 11.1-7.5 20.4-17.8 23.2zm-33 .8l-90.5 0c-1.8 5-2.7 10.4-2.7 16c0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16zM32 240c0-8.8 7.2-16 16-16l192 0 16 0 88 0 .3 0c40.2 0 77.3 21.5 97.2 56.4L541.9 456.1c4.4 7.7 1.7 17.4-6 21.8s-17.4 1.7-21.8-6L416 300.2 416 464c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-31.6c0-.2 0-.5 0-.7L224 256 48 256c-8.8 0-16-7.2-16-16zM256 464c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16l0-16-128 0 0 16zM384 296c0-4.3-.7-8.5-1.9-12.4L273.8 416 384 416l0-120zm-40-40l-88 0 0 131.2L360.4 259.5c-5-2.3-10.6-3.5-16.4-3.5z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPersonMilitaryPointing = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;